import { Newspaper } from "lucide-react";
import { useHelpStore } from "@/lib/store/help.store";

export const ReleaseNotesButton: React.FC = () => {
	const openReleases = useHelpStore((state) => state.openReleases);
	const unreadReleaseCount = useHelpStore(
		(state) => state.unreadReleaseCount
	);

	return (
		<button
			onClick={openReleases}
			className="relative flex items-center justify-center w-8 h-8 text-gray-700 rounded-md hover:bg-stone-200 transition-colors"
			aria-label="Neuigkeiten anzeigen"
			data-testid="release-notes-button"
		>
			<Newspaper className="h-4 w-4" />
			{unreadReleaseCount > 0 && (
				<div className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full" />
			)}
		</button>
	);
};
